module.exports = __webpack_public_path__ + "static/img/model-bg11.d520dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg11.jpg
// module id = w4/F
// module chunks = 0